query customerRepliesQuery($id: UUID!, $first: Int = 3, $offset: Int = 0) {
  comment: commentByCommentId(commentId: $id) {
    replies: threadsByCommentId(
      first: $first
      offset: $offset
      orderBy: CREATED_AT_DESC
    ) {
      totalCount
      nodes {
        id: threadId
        createdBy
        createdAt
        updatedAt
        edited
        content: threadContent
      }
    }
  }
}
